/**
 * Color schemes for all Base components
 *
 * Defines the color variants for each player's base (Red, Blue, Yellow, Green).
 * These schemes are used by the generic BaseComponent to render color-specific bases.
 */

import { SHARED_COLORS } from './constants';

export interface BaseColorScheme {
  name: string;
  ariaLabel: string;
  frame: string;
  innerColor1: string;
  innerColor2: string;
  innerColor3: string;
  pawnSpot: string;
  shadowBlack: string;
  grassGreen: string;
}

export const BASE_COLOR_SCHEMES = {
  red: {
    name: 'red',
    ariaLabel: 'Red player home base',
    frame: SHARED_COLORS.frame,
    innerColor1: '#EF4444', // Red inner section
    innerColor2: '#991B1B', // Dark red border
    innerColor3: '#B91C1C', // Dark red secondary
    pawnSpot: '#FCA5A5', // Light red pawn spots
    shadowBlack: SHARED_COLORS.shadow,
    grassGreen: SHARED_COLORS.grassGreen
  },
  blue: {
    name: 'blue',
    ariaLabel: 'Blue player home base',
    frame: SHARED_COLORS.frame,
    innerColor1: '#5176EF', // Blue inner section
    innerColor2: '#002899', // Dark blue border
    innerColor3: '#003DB5', // Dark blue secondary
    pawnSpot: '#55A2FF', // Light blue pawn spots
    shadowBlack: SHARED_COLORS.shadow,
    grassGreen: SHARED_COLORS.grassGreen
  },
  yellow: {
    name: 'yellow',
    ariaLabel: 'Yellow player home base',
    frame: SHARED_COLORS.frame,
    innerColor1: '#EAB308', // Medium yellow
    innerColor2: '#78350F', // Darkest yellow/brown
    innerColor3: '#92400E', // Dark yellow/brown
    pawnSpot: '#FDE047', // Light yellow pawn spots
    shadowBlack: SHARED_COLORS.shadow,
    grassGreen: SHARED_COLORS.grassGreen
  },
  green: {
    name: 'green',
    ariaLabel: 'Green player home base',
    frame: SHARED_COLORS.frame,
    innerColor1: '#22C55E', // Medium green
    innerColor2: '#14532D', // Darkest green
    innerColor3: '#166534', // Dark green
    pawnSpot: '#86EFAC', // Light green pawn spots
    shadowBlack: SHARED_COLORS.shadow,
    grassGreen: SHARED_COLORS.grassGreen
  }
} as const;

export type BaseColor = keyof typeof BASE_COLOR_SCHEMES;
